import environment from "environment";
import { requestService } from "../request";
import type { Params, Data } from "../dashboardApi";

export const downloadTransactionReport = (params: Params) => requestService
  .post(environment.endpoints.post.downloadTransactionReport, params);

export const getTransactionReportList = (params: Params): Promise<Data> => requestService
  .post(environment.endpoints.post.getDashboardData, params);

